module.exports = __webpack_public_path__ + "b73d04df604b119afe75db7f9b501858.png";